import React from 'react';
import { Col, Row } from 'antd';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import SimCardForm from './SimCardForm';
import { useParams } from 'react-router-dom';
import Page403 from '@page/Common/403/403';
import { usePermission } from '@contexts/Auth/UsePermission';

const AddSimCard = () => {
  const { id } = useParams();
  const { sim } = usePermission();

  if ((id && !sim.edit) || (!id && !sim.create)) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath="/dashboard"
          routeSegments={[
            { name: 'Quản lý SIM', path: '/sim-cards' },
            { name: id ? 'Cập nhật SIM' : 'Thêm mới SIM' }
          ]}
        />
      </div>
      <Row>
        <Col span={24}>
          <SimCardForm />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default AddSimCard;
